import React from "react";
import { FormattedMessage } from "react-intl";

import { useIntlTranslate } from "../../hooks";
import { formatDuration } from "./pauseInternet.helpers";
import { usePauseInternet } from "./PauseInternetProvider";

import "./PausedInternetTimeLeft.scss";

export const PausedInternetTimeLeft = () => {
  const translate = useIntlTranslate();
  const { timeLeft } = usePauseInternet();

  const shortHour = translate("short_hour");
  const shortMinute = translate("short_minute");

  return (
    <span className="paused-internet-time-left">
      <FormattedMessage
        id="internet_paused"
        values={{
          pausedTime: (
            <span className="paused-internet-time-left__value">
              {formatDuration(timeLeft, shortHour, shortMinute)}
            </span>
          ),
        }}
      />
    </span>
  );
};
